import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ImportTransactionsModal from '../components/ImportTransactionsModal';

const ImportModalContext = createContext(null);

export const ImportModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState({ portfolioId: null, onSuccess: null, defaultTab: 'file', initialCSV: '', assetKind: 'crypto' });

  const openImportModal = useCallback(({ portfolioId, onSuccess, defaultTab = 'file', initialCSV = '', assetKind = 'crypto' } = {}) => {
    setModalProps({ portfolioId: portfolioId || null, onSuccess: onSuccess || null, defaultTab, initialCSV, assetKind });
    setIsOpen(true);
  }, []);

  const closeImportModal = useCallback(() => {
    setIsOpen(false);
    // keep last props in case caller reopens quickly; we can clear if needed
  }, []);

  const value = useMemo(() => ({ openImportModal, closeImportModal }), [openImportModal, closeImportModal]);

  return (
    <ImportModalContext.Provider value={value}>
      {children}
      <ImportTransactionsModal
        isOpen={isOpen}
        onClose={closeImportModal}
        portfolioId={modalProps.portfolioId}
        onSuccess={modalProps.onSuccess || undefined}
        defaultTab={modalProps.defaultTab}
        initialCSV={modalProps.initialCSV}
        assetKind={modalProps.assetKind}
      />
    </ImportModalContext.Provider>
  );
};

export const useImportModal = () => {
  const ctx = useContext(ImportModalContext);
  if (!ctx) throw new Error('useImportModal must be used within ImportModalProvider');
  return ctx;
};


